<template>
  <template v-if="question?.status !== 'READ_ONLY'">
    <div
        class="inputContainer"
        :class="{ invalid: error && hasBeenInteractedWith, 'container-menu-opened': true,  'border-setup': !hasBeenInteractedWith, }"
        role="combobox"
        aria-haspopup="listbox"
        @keydown.enter="confirm"
        @blur="$emit('user-interaction'); confirm;"
        @tab="confirm"
        v-bind="$attrs"
        ref="chipContainer"
    >
      <div class="d-flex flex-wrap " :class="{'chip-container':true}">
        <div id="values-output" v-for="(selection, i) in question?.options ?? []" :key="`${selection.value}_${i}`">
          <div class="d-inline-block chip me-2 mb-2" tabindex="0" :class="{selected: selectedValues[selection.value]}"
               @keydown.space.stop.prevent="selectedValues[selection.value] = !selectedValues[selection.value]"
               @click.stop.prevent="selectedValues[selection.value] = !selectedValues[selection.value];focused=true">
            <span data-testid="selected-value">{{ selection?.text }}</span>
          </div>
        </div>
      </div>

    </div>
    <slot name="helptext" :isConfirm="!disableConfirm && (question.value && question?.prefilled) && !error" :isError="error"
          :confirmCb="() => {$emit('user-interaction');$emit('confirm');}"></slot>
  </template>
  <ReadOnly
      v-else
      :question="question"
      :value="Object.keys(selectedValues).length ? Object.keys(selectedValues).filter(k => selectedValues[k]).join(','):'-'"
      :forcePromptPlaceholder="forcePromptPlaceholder"
  />
</template>

<script>
import ReadOnly from "@/components/waffle/components/form-components/ReadOnly.vue";

export default {
  name: "ChipChoices",
  components: {ReadOnly},
  props: {
    disableConfirm:Boolean,
    question: {
      type: Object,
      required: true,
    },
    modelValue: {
      type: [String, Object],
      required: false,
    },
    hideSubText: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    forcePromptPlaceholder: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    skipEagerValidation: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    hasBeenInteractedWith:Boolean,
    disabled:Boolean
  },
  data() {
    return {
      selectedValues: {},
      error: "",
      shouldConfirm: false,
      focused:false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
    this.question.value?.split(',').forEach(value => {
      const found = (this.question.options || [])?.find((item) => {
        return item?.value?.includes(value)
      })
      if (found) {
        this.selectedValues[found.value] = true
      } else {
        this.selectedValues[value] = false;
      }
    })

    if (
        this.question.required &&
        !Object.values(this.selectedValues).some(el => el) &&
        !this.skipEagerValidation
    ) {
      this.error = "Required";
      return this.$emit("field-error", true);
    }
  },
  emits: ["update:modelValue", "field-error",'confirm','user-interaction'],
  watch: {
    selectedValues: {
      handler() {
        const result = Object.keys(this.selectedValues)?.filter(k => this.selectedValues[k])?.join(',')
        if (!result?.length && this.question.required) {
          this.error = "Required";
          this.$emit("field-error", true);
        } else {
          this.error = "";
          // if(this.disableConfirm){
          //   this.confirm()
          // }
          this.$emit("field-error", false);
        }
      },
      deep: true
    },
    question: {
      handler(newQuestion) {
        if (newQuestion.error) {
          this.error = newQuestion.error;
          return this.$emit("field-error", true);
        }
        if (newQuestion.value) {
          const currentResult = Object.keys(this.selectedValues)?.filter(k => this.selectedValues[k])?.join(',')
          if(newQuestion.value !== currentResult){
            this.$emit('update:modelValue',newQuestion.value );
          }
          newQuestion.value?.split(',').forEach(value => {
            const found = (newQuestion.options || [])?.find((item) => {
              return item?.value?.includes(value)
            })
            if (found) {
              this.selectedValues[found.value] = true
            } else {
              this.selectedValues[value] = false;
            }
          })
        }
      }
      ,
      deep: true,
    }
    ,
  },
  beforeUnmount() {
    // Remove the click event listener when the component is unmounted
    document.removeEventListener('click', this.handleDocumentClick);
  },
  methods: {
    handleDocumentClick(event) {
      this.$emit('user-interaction')
      const divElement = this.$refs.chipContainer; // Access the div using the ref
      if (divElement && !divElement.contains(event.target)) {
        this.confirm();
      }
    },
    confirm() {
      if(this.focused){
        this.$emit('update:modelValue', Object.keys(this.selectedValues)?.filter(k => this.selectedValues[k])?.join(','));
        if(this.question.value && !this.disableConfirm){
          this.$emit('confirm')
        }
      }
      this.focused = false
    },
    handleKeyDown(e) {
      if (e.key === "space") {
        e.preventDefault()

      }
    }
    ,
  }
  ,
}
;
//TODO:CLEAN UP AND REFINE CSS
</script>

<style scoped lang="scss">
.align-text-end {
  text-align: end;
}

.placeholder-float {
  font-size: 12px !important;
  //padding: 2px 8px 5px 16px !important;
}

.chip-container {
  padding: 24px 16px 16px;
}

.chip {
  border-radius: 40px;
  padding: 12px 14px;
  background-color: #EEEEEE;
}

.choice {
  border: none;
}

.selected {
  background-color: black;
  color: white
}

.noOptions {
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.subtext {
  font-size: 0.75rem;
  font: normal normal normal 12px/18px Roboto;
  letter-spacing: 0px;
  margin-bottom: 4px;
  color: #757575;
}

.errorMessage {
  color: #bb0000;
}

.quill-question-placeholder {
  position: absolute;
  //padding: 14px 16px;
  line-height: 2em;
  top: 0;
  left: 0;
  color: #757575;
  font-size: 16px;
  pointer-events: none;
  transform: scale(1);
  transition: 0.26s all ease;
}

.quill-question {
  > div {
    position: relative;
    cursor: pointer;

    > .quill-question-input,
    {
      box-sizing: border-box;
      border-radius: 3px;
      width: 100%;
      min-height: 48px;
      font-size: 16px;
      background: transparent;
      outline: none;
      height: 0;
      font-weight: bold;
    }


    > ul {
      list-style: none;
      padding: 0;
      position: absolute;
      top: calc(100% - 1px);
      background: white;
      border: 1px solid #21212122;
      box-shadow: 3px 3px 10px #21212122;
      width: 100%;
      z-index: 9;
      visibility: hidden;
      transition-delay: 0.13s;
      max-height: 200px;
      overflow: auto;

      > li {
        padding: 2px 15px;
        cursor: pointer;

        &:hover {
          font-weight: bold;
          color: #525252;
          background: #f8f8f8;
        }

        &.selected {
          font-weight: bold;
          color: #525252;
          background: #ededed;
        }
      }
    }

    > i {
      content: "";
      display: block;
      width: 10px;
      height: 10px;
      position: absolute;
      top: 16px;
      right: 16px;
      border-style: solid;
      border-width: 0 3px 3px 0;
      color: #525252;
      transform: rotate(45deg);
      transition: 0.26s all ease;
    }
  }

  > b {
    color: red;
    display: none;
  }

  &.error {
    > b {
      display: block;
    }

    > div {
      border-color: red;
    }
  }

  > u {
    display: block;
    text-align: right;
    text-decoration: underline;
    cursor: pointer;
  }
}

/*TODO convert to scss*/

.quill-question > label > i > svg:hover:hover ~ span {
  visibility: visible;
  transition-delay: 0.31s;
}

.quill-question > div.inputContainer .quill-question-input:focus,
.quill-question
> div.inputContainer
.quill-question-input:not(.radio, :placeholder-shown) {
  padding: 16px 16px 8px 16px;
}

.quill-question > div.inputContainer .chip-container + .quill-question-placeholder {
  font-size: 16px;
  //padding: 8px 8px 5px 16px;
}

.quill-question > div.inputContainer.container-menu-opened > ul {
  /*display: block;*/
  visibility: visible;
  transition-delay: 0.1s;
}

.quill-question > div.inputContainer.container-menu-opened > i {
  transform: rotate(225deg);
}

// Start Floating Label CSS
.quill-question > div.inputContainer .chip-container + .quill-question-placeholder {
  font-size: 12px;
  padding: 2px 8px 5px 16px !important;
}

.form-floating > .form-control:focus ~ label.form-label-text, .form-floating > .form-control:focus ~ label {
  font-size: 12px;
  color: #484848;
  padding-top: 1rem;
}

.form-control-disabled:hover {
  border: none;
}

.form-control-enabled:hover {
  border: 2px solid #212121
}

// End Floating Label CSS

.invalid {
  border: 1px solid #bb0000 !important;

  &:hover,
  &:focus,
  &:focus-within {
    border: 2px solid #bb0000 !important;
  }
}
</style>
